import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import Viewer from './Viewer';

function ModelRoute() {
  const { modelName } = useParams();
  return <Viewer modelName={modelName} />;
}

function App() {
  return (
    <Routes>
      <Route path="/:modelName" element={<ModelRoute />} />
      <Route path="*" element={<div>Modell nicht gefunden</div>} />
    </Routes>
  );
}

export default App;